<template>
  <div v-if="externalStatusArr.length" style="border-bottom: 1px solid #f5f5f5; margin-top: -10px;">
    <ul id="breadcrumb">
      <li><a href="#"><i class="fal fa-flag"></i> </a></li>
      <li><a href="#">Submitted</a></li>
      <li><a href="#">Verified</a></li>
      <li><a href="#">Current</a></li>
      <li><a href="#">Delivered</a></li>
      <li><a href="#"><i class="fal fa-flag"></i> </a></li>
    </ul>

  </div>
</template>

<script>
import {GET_EXTERNAL_STATUS} from '../../graphql/queries/status'
export default {
    apollo: {
        externalstatus: {
            query: GET_EXTERNAL_STATUS,
            skip: false,
            result ({ data, loading }) {
                if (!loading) {
                    this.externalStatusArr = data.externalstatus;
                }
            }
        },
    },
    name: "ExternalStatusBar",
    data:function(){
        return{
            externalStatusArr: []
        }
    }
}
</script>

<style scoped>
  #breadcrumb {
    list-style: none;
    display: inline-block;
  }
  #breadcrumb .icon {
    font-size: 14px;
  }
  #breadcrumb li {
    float: left;
  }
  #breadcrumb li a {
    color: #262626;
    display: block;
    background: #cdcdcd;
    text-decoration: none;
    position: relative;
    height: 30px;
    line-height: 30px;
    padding: 0 10px 0 5px;
    text-align: center;
    margin-right: 23px;
  }
  #breadcrumb li:nth-child(even) a {
    background-color: #cdcdcd;
  }
  #breadcrumb li:nth-child(even) a:before {
    border-color: #cdcdcd;
    border-left-color: transparent;
  }
  #breadcrumb li:nth-child(even) a:after {
    border-left-color: #cdcdcd;
  }
  #breadcrumb li:first-child a {
    padding-left: 15px;
    -moz-border-radius: 4px 0 0 4px;
    -webkit-border-radius: 4px;
    border-radius: 4px 0 0 4px;
  }
  #breadcrumb li:first-child a:before {
    border: none;

  }
  #breadcrumb li:last-child a {
    padding-right: 15px;
    -moz-border-radius: 0 4px 4px 0;
    -webkit-border-radius: 0;
    border-radius: 0 4px 4px 0;
  }
  #breadcrumb li:last-child a:after {
    border: none;
  }
  #breadcrumb li a:before, #breadcrumb li a:after {
    content: "";
    position: absolute;
    top: 0;
    border: 0 solid #cdcdcd;
    border-width: 15px 10px;
    width: 0;
    height: 0;
  }
  #breadcrumb li a:before {
    left: -20px;
    border-left-color: transparent;
  }
  #breadcrumb li a:after {
    left: 100%;
    border-color: transparent;
    border-left-color: #cdcdcd;
  }
  #breadcrumb li a:hover {
    background-color: #2d8cf0;
  }
  #breadcrumb li a:hover:before {
    border-color: #2d8cf0;
    border-left-color: transparent;
  }
  #breadcrumb li a:hover:after {
    border-left-color: #2d8cf0;
  }
  #breadcrumb li a:active {
    background-color: #16a085;
  }
  #breadcrumb li a:active:before {
    border-color: #16a085;
    border-left-color: transparent;
  }
  #breadcrumb li a:active:after {
    border-left-color: #16a085;
  }

</style>
